import { Orientation, type SerializedDockview } from 'dockview';
import type { TypedGroupviewPanelState } from '../../../../types/LayoutConfig';
import { BRANCH, LEAF } from '../../../Layout/tokens';

const PANELS: Record<string, TypedGroupviewPanelState> = {
  btcMarketCap: {
    id: 'btcMarketCap',
    contentComponent: 'aggregatedAssetMetric',
    title: 'BTC - Market Cap (Est.)',
    params: { type: 'aggregatedAssetMetric', selectedCmAssetIds: ['btc'], metric: 'CapMrktEstUSD' },
  },
  relativePerformance: {
    id: 'relativePerformance',
    contentComponent: 'relativePerformance',
    title: 'Relative Performance',
    params: { type: 'relativePerformance', cmAssetIds: ['btc', 'eth', 'sol'] },
  },
  fundingRateHistory: {
    id: 'fundingRateHistory',
    contentComponent: 'historicalFundingRate',
    title: 'Funding Rate History (USD Aggregated)',
    params: { type: 'historicalFundingRate', cmAssetId: 'btc' },
  },
  fundingRateMatrix: {
    id: 'fundingRateMatrix',
    contentComponent: 'fundingRateBlotter',
    title: 'Funding Rate - Matrix (USD Aggregated)',
    params: { type: 'fundingRateBlotter', defaultView: 'Matrix' },
  },
};

const GRID: SerializedDockview['grid'] = {
  root: {
    type: BRANCH,
    data: [
      {
        type: BRANCH,
        data: [
          {
            type: LEAF,
            visible: true,
            data: { views: ['btcMarketCap'], activeView: 'btcMarketCap', id: 'btcMarketCap' },
            size: 800,
          },
          {
            type: LEAF,
            visible: true,
            data: { views: ['relativePerformance'], activeView: 'relativePerformance', id: 'relativePerformance' },
            size: 800,
          },
        ],
        size: 450,
      },
      {
        type: BRANCH,
        data: [
          {
            type: LEAF,
            visible: true,
            data: { views: ['fundingRateHistory'], activeView: 'fundingRateHistory', id: 'fundingRateHistory' },
            size: 800,
          },
          {
            type: LEAF,
            visible: true,
            data: { views: ['fundingRateMatrix'], activeView: 'fundingRateMatrix', id: 'fundingRateMatrix' },
            size: 800,
          },
        ],
        size: 450,
      },
    ],
    size: 900,
  },
  width: 1600,
  height: 900,
  orientation: Orientation.VERTICAL,
};

export const DEFAULT_INTEL_OVERVIEW_LAYOUT: SerializedDockview = {
  grid: GRID,
  panels: PANELS,
};
